import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChildren, ElementRef, Inject, Input, Optional, QueryList, ViewEncapsulation } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzMenuItemComponent } from "ng-zorro-antd/menu";
import { UiMenuService } from "../../services/menu.service";
import { UiSubmenuService } from "../../services/submenu.service";
import { UiIsMenuInsideDropDownToken } from "../../utils/menu.utils";

@Component({
  selector: "[ui-menu-item]",
  exportAs: "uiMenuItem",
  templateUrl: "./menu-item.component.html",
  styleUrls: ["./menu-item.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  standalone: true,
})
export class UiMenuItemComponent extends NzMenuItemComponent {
  @Input("uiPaddingLeft") public nzPaddingLeft?: number;
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Input("uiSelected") @InputBoolean() public nzSelected = false;
  @Input("uiDanger") @InputBoolean() public nzDanger = false;
  @Input("uiMatchRouterExact") @InputBoolean() public nzMatchRouterExact = false;
  @Input("uiMatchRouter") @InputBoolean() public nzMatchRouter = false;
  @ContentChildren(RouterLink, { descendants: true }) public listOfRouterLink!: QueryList<RouterLink>;
  @ContentChildren(RouterLink, { descendants: true }) public listOfRouterLinkWithHref!: QueryList<RouterLink>;

  constructor(
    uiMenuService: UiMenuService,
    cdr: ChangeDetectorRef,
    @Optional() uiSubmenuService: UiSubmenuService,
    @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean,
    @Optional() directionality: Directionality,
    private elementRef: ElementRef<HTMLElement>,
    @Optional() routerLink?: RouterLink,
    @Optional() router?: Router
  ) {
    super(uiMenuService, cdr, uiSubmenuService, isMenuInsideDropDown, directionality, routerLink, router);
  }

  public focus(): void {
    this.elementRef.nativeElement.focus();
  }
}
